import { sendEvents } from '@fiverr-private/futile/lib/send/sendEvents';

export const BQ_EVENT_TYPES = {
    OPEN_COUPON_ARTICLE: 'clicked_on_learn_more_about_coupons',
    SEEN_BOMBA_COUPON: 'learn_more_about_coupons_bomba_is_shown',
    SEEN_COUPON_MODAL: 'coupon_popup_is_shown',
    CLICKED_COUPON_MODAL: 'clicked_on_get_coupon_at_popup',
    CLICKED_VIEW_COUPON_VIA_EMAIL: 'clicked_on_view_coupon_via_email',
    CLICKED_VIEW_COUPON_VIA_NOTIFICATION: 'clicked_on_view_coupon_notification'
};

/**
 * Report BI Event to BigQuery
 * @param  {String}  type event type
 * @param  {object}  data - base parameters
 * @param  {object}  extraParams - additional parameters
 */
export default function reportEvent(type, data, extraParams = {}) {
    const {
        userId,
        sellerId,
        activeGigsCount
    } = data;

    const baseEventData = {
        group: 'seller_page',
        user: {
            id: userId
        },
        seller: {
            id: sellerId,
            active_gigs_count: activeGigsCount
        },
        page: {
            name: 'seller_page'
        }
    };

    sendEvents({
        ...baseEventData,
        ...extraParams,
        type
    });
}
